import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import FormField from '../../../dynamicFormBuilder/FormField'
import axios from "axios";
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import { LoadPanel } from 'devextreme-react/load-panel';
import notify from 'devextreme/ui/notify';
import { custom, confirm } from 'devextreme/ui/dialog';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import Toolbar, { Item } from "devextreme-react/toolbar";
import DimensionsTab from './tabs/DimensionsTab';
import UserDefinedTab from './tabs/UserDefinedTab';
import { PrimaryLayout } from './Layout';
import ProximityTab from './tabs/ProximityTab';
import { IM, WM } from "../../../const/constants";
import ValidationSummary from 'devextreme-react/validation-summary';
import { MESSAGES } from "../../../common/Messages";
import routes from "../../../assets/apiRoutes.json";
import PrimaryTab from "./tabs/PrimaryTab";
import { locationTypes, optionsYesNo, status } from "../../../const/Lookup";
import { GetFormatedDateWithTime, loadLookupFromStaticDataSource } from "../../../common/Utils";
import { LocationStatus,LocationTypes as LocType,Options } from "../../../enum/Enum";
var skipDataLoading = false;
function LocationDataEntryForm(props) {
    const [dialogVisible, setDialogVisible] = useState(false);
    const [selectionPriority, setSelectionPriority] = useState(1);
    const openDialog = async () => {
        setDialogVisible(true);
    };
    const closeDialog = () => {
        setDialogVisible(false);
    };
    const initialFormFields = {
        RowId: '00000000-0000-0000-0000-000000000000',
        KeySequence: 1,
        Record: null,
        RProfile: null,
        RWarehouse: null,
        LocationCode: null,
        Description: null,
        Status: LocationStatus.AllowAll,
        LocationType:LocType.StagingLocation,
        RLocation: null,
        Priority: null,
        ClassCode: null,
        SubClassCode: null,
        PickSequence: null,
        Comment: null,
        Module: props.Module,
        MinPositionIndex: null,
        MaxPositionIndex: null,
        Height: null,
        Width: null,
        Depth: null,
        CapacityLimitFlag: Options.No,
        CapacityPiecesLimitFlag: Options.No,
        CapacityShippingUnitsLimitFlag: Options.No,
        CapacityContainerLimitFlag: Options.No,
        CapacityGrossWeightLimitFlag: Options.No,
        CapacityNetWeightLimitFlag: Options.No,
        CapacityAreaLimitFlag: Options.No,
        CapacityVolumeLimitFlag: Options.No,
        CapacityUnits: null,
        CapacityPieces: null,
        CapacityShippingUnits: null,
        CapacityContainerUnits: null,
        CapacityGrossWeight: null,
        CapacityNetWeight: null,
        CapacityArea: null,
        CapacityVolume: null,
        Area: null,
        Volume: null,
        IntHeight: null,
        IntWidth: null,
        IntDepth: null,
        UpdateDimensionOptions: 0,
        UserDefinedCode1: null,
        UserDefinedCode2: null,
        UserDefinedCode3: null,
        UserDefinedCode4: null,
        UserDefinedCode5: null,
        UserDefinedCode6: null,
        UserDefinedCode7: null,
        UserDefinedCode8: null,
        UserDefinedCode9: null,
        UserDefinedCode10: null,
        UserDefinedDate1: null,
        UserDefinedDate2: null,
        UserDefinedDate3: null,
        UserDefinedDate4: null,
        UserDefinedDate5: null,
        UserDefinedDate6: null,
        UserDefinedDate7: null,
        UserDefinedDate8: null,
        UserDefinedDate9: null,
        UserDefinedDate10: null,
        UserDefinedQuantity1: null,
        UserDefinedQuantity2: null,
        UserDefinedQuantity3: null,
        UserDefinedQuantity4: null,
        UserDefinedQuantity5: null,
        UserDefinedQuantity6: null,
        UserDefinedQuantity7: null,
        UserDefinedQuantity8: null,
        UserDefinedQuantity9: null,
        UserDefinedQuantity10: null,
        UserDefinedReference1: null,
        UserDefinedReference2: null,
        UserDefinedReference3: null,
        UserDefinedReference4: null,
        UserDefinedReference5: null,
        UserDefinedReference6: null,
        UserDefinedReference7: null,
        UserDefinedReference8: null,
        UserDefinedReference9: null,
        UserDefinedReference10: null,
    };
    const [formFields, setformFields] = useState(initialFormFields);
    const formFieldsRef = useRef(formFields);
    const history = useHistory();
    var accessToken = props.oidc.user.access_token;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, [setLoadPanelVisible]);
    const position = { of: '#accordion-containe2' };
    var currentUser = props.oidc.user;
    const formRefs = useRef({});
    useEffect(() => {
        if (formFields)
            formFieldsRef.current = formFields;
    }, [formFields])

    const handleFormSubmit = async (e) => {
        setLoadPanelVisible(true);
        setIsFormSubmitted(true);
        try {
            e.preventDefault();
            const width = formFields.Width || 0;
            const height = formFields.Height || 0;
            const depth = formFields.Depth || 0;
            const INT_WIDTH = formFields.IntWidth || 0;
            const INT_HEIGHT = formFields.IntHeight || 0;
            const INT_DEPTH = formFields.IntDepth || 0;
            if ((width != INT_WIDTH) || (depth != INT_DEPTH) || (height != INT_HEIGHT)) {
                setformFields(prevFields => ({
                    ...prevFields,
                    UpdateDimensionOptions: 1,
                }));
                await openDialog();
            }
            else {
                if (formFields.RowId == "00000000-0000-0000-0000-000000000000") {
                    await postTransaction();
                }
                else {
                    await updateTransaction();
                }
            }

        } catch (error) {
            console.error('Error submitting form:', error);
            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };
    const handleChangeDimensionButtonClick = async (selectionPriority) => {
        if (formFields.RowId == "00000000-0000-0000-0000-000000000000") {
            await postTransaction();
        }
        else {
            await updateTransaction();
        }
        closeDialog();
    };

    const postTransaction = async () => {
        try {
            setLoadPanelVisible(true);
            let fields = formatDates();
            const response = await axios.post(`${window._env_.REACT_APP_APIS}/${routes.IM.CreateLocationData}`, fields, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });
            if (response.data.issuccess) {

                setformFields(prevFields => ({
                    ...prevFields,
                    RowId: response.data.rowid,
                    Record: response.data.recordno,
                }));
                notify(
                    {
                        message: MESSAGES.UPDATE_SUCCESS,
                        width: 300,
                    },
                    'success',
                    3000,
                );
            } else {
                const errorHtml = (response.data.message || "").replace(/\\r\\n|\r\n|\n/g, "<br/>");
                custom({
                    title: "Errors",
                    messageHtml: errorHtml,
                    buttons: [{ text: "OK", onClick: () => { } }]
                }).show();
                setIsFormSubmitted(false);
            }

        } 
        catch (error) 
        {
            if (error.response && error.response.status === 400)
            {
                var errorHtml = "";
                for (const fieldName in error.response.data) 
                {
                    if (Object.hasOwnProperty.call(error.response.data, fieldName)) {
                      const messages = error.response.data[fieldName];
                      messages.forEach(message => {
                        errorHtml += `${message}<br/>`;
                      });
                    }
                }

                custom({
                    title: "Errors",
                    messageHtml: errorHtml,
                    buttons: [{ text: "OK", onClick: () => { } }]
                }).show();

            } 
            else 
            {
                console.error('An error occurred:', error);
                custom({
                    title: "Errors",
                    messageHtml: "An unexpected error occurred. Please try again.",
                    buttons: [{ text: "OK", onClick: () => { } }]
                }).show();
            }

            setIsFormSubmitted(false);
        } 
        finally 
        {
            setTimeout(hideLoadPanel, 1000);
            setLoadPanelVisible(false);
        }
    };
    const updateTransaction = async () => {
        try 
        {
            setLoadPanelVisible(true);
            let fields = formatDates();
            const response = await axios.put(`${window._env_.REACT_APP_APIS}/${routes.IM.UpdateLocationData}`, fields, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });
            if (response.data.issuccess) 
            {

                notify(
                    {
                        message: MESSAGES.UPDATE_SUCCESS,
                        width: 300,
                    },
                    'success',
                    3000,
                );
                var rowid = props.id;
                if (rowid != null && rowid != undefined && rowid != '') {
                    GetHeaderInfoById(rowid);
                }
            } 
            else 
            {
                const errorHtml = (response.data.message || "").replace(/\\r\\n|\r\n|\n/g, "<br/>");
                custom({
                    title: "Errors",
                    messageHtml: errorHtml,
                    buttons: [{ text: "OK", onClick: () => { } }]
                }).show();
                setIsFormSubmitted(false);
            }

        }
        catch (error) 
        {
            if (error.response && error.response.status === 400)
            {
                var errorHtml = "";
                for (const fieldName in error.response.data) 
                {
                    if (Object.hasOwnProperty.call(error.response.data, fieldName)) {
                      const messages = error.response.data[fieldName];
                      messages.forEach(message => {
                        errorHtml += `${message}<br/>`;
                      });
                    }
                }

                custom({
                    title: "Errors",
                    messageHtml: errorHtml,
                    buttons: [{ text: "OK", onClick: () => { } }]
                }).show();

            } 
            else 
            {
                console.error('An error occurred:', error);
                custom({
                    title: "Errors",
                    messageHtml: "An unexpected error occurred. Please try again.",
                    buttons: [{ text: "OK", onClick: () => { } }]
                }).show();
            }

            setIsFormSubmitted(false);
        } 
        finally 
        {
            setTimeout(hideLoadPanel, 1000);
            setLoadPanelVisible(false);
        }
    };
    const formatDates = () => {
        let fields = formFields;
        fields.UserDefinedDate1 = GetFormatedDateWithTime(formFields.UserDefinedDate1);
        fields.UserDefinedDate2 = GetFormatedDateWithTime(formFields.UserDefinedDate2);
        fields.UserDefinedDate3 = GetFormatedDateWithTime(formFields.UserDefinedDate3);
        fields.UserDefinedDate4 = GetFormatedDateWithTime(formFields.UserDefinedDate4);
        fields.UserDefinedDate5 = GetFormatedDateWithTime(formFields.UserDefinedDate5);
        fields.UserDefinedDate6 = GetFormatedDateWithTime(formFields.UserDefinedDate6);
        fields.UserDefinedDate7 = GetFormatedDateWithTime(formFields.UserDefinedDate7);
        fields.UserDefinedDate8 = GetFormatedDateWithTime(formFields.UserDefinedDate8);
        fields.UserDefinedDate9 = GetFormatedDateWithTime(formFields.UserDefinedDate9);
        fields.UserDefinedDate10 = GetFormatedDateWithTime(formFields.UserDefinedDate10);
        return fields;
    };
    const handleReset = () => {
        var rowid = props.id;
        if (rowid != null && rowid != undefined && rowid != '') {
            GetHeaderInfoById(rowid);
        }
        else {
            skipDataLoading = true;
            setformFields(initialFormFields);
            skipDataLoading = false;
            EnableDisableControls();
        }
    };
    const GetHeaderInfoById = (id) => {
        try {
            setLoadPanelVisible(true);
            const response = axios.get(`${window._env_.REACT_APP_APIS}/${routes.IM.GetLocationDataByRowId}?rowid=${id}`, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            }).then((res) => {
                const responseData = res.data;
                console.log(responseData)
                if (responseData.RowId) {
                    skipDataLoading = true;
                    setformFields(responseData);
                    skipDataLoading = false;
                }
                else {
                    console.error(MESSAGES.FETCH_ERROR);
                }
            });


        } catch (error) {
            console.error(MESSAGES.FETCH_ERROR, error);
        } finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };
    const EnableDisableControls = () => {
    }
    useEffect(() => {
        var rowid = props.id;
        if (rowid != null && rowid != undefined && rowid != '') {
            GetHeaderInfoById(rowid);
        }
        else {
            EnableDisableControls();
        }
    }, []);
    const goBack = () => {
        if (props.Module === WM)
            history.push("/wm/codes/location-data-entry");
        else if (props.Module === IM)
            history.push("/im/codes/location-data-entry");
    };
    const handleFieldChange = useCallback((name, value, e, formRefs) => {
        if (name == "Height") {
            setformFields(prevFields => {
                const width = prevFields.Width || 0;
                const depth = prevFields.Depth || 0;
                const height = value;
                const area = width * depth;
                const volume = (width * depth) * height;
                return {
                    ...prevFields,
                    Area: area,
                    Volume: volume,
                };
            });
        }
        if (name == "Depth") {
            setformFields(prevFields => {
                const width = prevFields.Width || 0;
                const depth = value;
                const height = prevFields.Height || 0;
                const area = width * depth;
                const volume = (width * depth) * height;
                return {
                    ...prevFields,
                    Area: area,
                    Volume: volume,
                };
            });
        }
        if (name == "Width") {
            setformFields(prevFields => {
                const width = value;
                const depth = prevFields.Depth || 0;
                const height = prevFields.Height || 0;
                const area = width * depth;
                const volume = (width * depth) * height;
                return {
                    ...prevFields,
                    Area: area,
                    Volume: volume,
                };
            });
        }
    }, []);
    const handlePrimaryFormLoad = useCallback((formRefs) => {
        loadLookupFromStaticDataSource("Status", status, formFields, formRefs);
        loadLookupFromStaticDataSource("LocationType", locationTypes, formFields, formRefs);
    }, []);
    const handleDimensionFormLoadCodes = useCallback((formRefs) => {
        loadLookupFromStaticDataSource("CapacityLimitFlag", optionsYesNo, formFields, formRefs);
        loadLookupFromStaticDataSource("CapacityPiecesLimitFlag", optionsYesNo, formFields, formRefs);
        loadLookupFromStaticDataSource("CapacityShippingUnitsLimitFlag", optionsYesNo, formFields, formRefs);
        loadLookupFromStaticDataSource("CapacityContainerLimitFlag", optionsYesNo, formFields, formRefs);
        loadLookupFromStaticDataSource("CapacityGrossWeightLimitFlag", optionsYesNo, formFields, formRefs);
        loadLookupFromStaticDataSource("CapacityNetWeightLimitFlag", optionsYesNo, formFields, formRefs);
        loadLookupFromStaticDataSource("CapacityAreaLimitFlag", optionsYesNo, formFields, formRefs);
        loadLookupFromStaticDataSource("CapacityVolumeLimitFlag", optionsYesNo, formFields, formRefs);
    }, []);
    const addNewRecordClick = () => {
        setIsFormSubmitted(false);
        skipDataLoading = true;
        setformFields(initialFormFields);
        skipDataLoading = false;
        if (props.Module === IM)
            history.push('/im/codes/location-data-entry-create');
        else if (props.Module === WM)
            history.push('/wm/codes/location-data-entry-create');
        EnableDisableControls();
    }
    const deleteRecords = useCallback(() => {
        let result = confirm(`<i>${MESSAGES.DELETE_CONFIRM}</i>`, "Delete");
        result.then((dialogResult) => {
            if (dialogResult) {
                axios.post
                    (
                        `${window._env_.REACT_APP_APIS}/${routes.IM.DeleteLocation}`,
                        formFields.RowId,
                        {
                            headers: {
                                "Content-Type": "application/json",
                                access_token: accessToken,
                            },
                        }
                    )
                    .then((res) => {
                        notify(
                            {
                                message: MESSAGES.DELETE_SUCCESS,
                                width: 300,
                            },
                            'success',
                            3000,
                        );
                        goBack();
                    })
                    .catch((err) => {
                    });

            }
        });

    }, [formFields.RowId]);
    return (
        <>
            <div>
                <div className="row dataEntryMainPage">
                    <div className="col-md-12 main-page">
                        <div id="accordion">

                            <LoadPanel
                                shadingColor="rgba(0,0,0,0.4)"
                                position={position}
                                onHiding={hideLoadPanel}
                                visible={loadPanelVisible}
                                showIndicator={true}
                                shading={true}
                                showPane={true}
                                hideOnOutsideClick={false}
                            />
                            <form onSubmit={(e) => handleFormSubmit(e)}>
                                <Toolbar className="header">
                                    <Item location="before">
                                        <div className="title">
                                            <h6
                                                style={{
                                                    color: window._env_.Color2,
                                                    marginLeft: '12px'
                                                }}
                                            >
                                                Enter Location Codes
                                            </h6>
                                        </div>
                                    </Item>
                                    <Item location="after">
                                        <Button
                                            text="Save"
                                            useSubmitBehavior={true}
                                            type="default"
                                            className="accordianButton"
                                        />
                                    </Item>
                                    <Item location="after">
                                        <Button className="accordianButton" onClick={addNewRecordClick} text="New" type="default" />
                                    </Item>
                                    <Item location="after">
                                        <Button
                                            text="Delete"
                                            type="default"
                                            className="accordianButton"
                                            onClick={deleteRecords}
                                            disabled={formFields.RowId === '00000000-0000-0000-0000-000000000000'}
                                        />
                                    </Item>
                                    <Item location="after">
                                        <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                    </Item>
                                    <Item location="after">
                                        <Button className="accordianButton" onClick={goBack} text="Back" />
                                    </Item>

                                </Toolbar>
                                <div className="AccordionItemBody">
                                    <TabPanel className="TabpanelContainer">
                                        <TabItem title="Primary">
                                            <PrimaryTab
                                                formFields={formFields}
                                                setformFields={setformFields}
                                                formRefs={formRefs}
                                                handlePrimaryFormLoad={handlePrimaryFormLoad}
                                                handleFieldChange={handleFieldChange}
                                                Module ={props.Module}
                                            />
                                        </TabItem>
                                        <TabItem title="Dimensions">
                                            <DimensionsTab
                                                formFields={formFields}
                                                setformFields={setformFields}
                                                formRefs={formRefs}
                                                dialogVisible={dialogVisible}
                                                closeDialog={closeDialog}
                                                handleChangeDimensionButtonClick={handleChangeDimensionButtonClick}
                                                selectionPriority={selectionPriority}
                                                setSelectionPriority={setSelectionPriority}
                                                handleDimensionFormLoadCodes={handleDimensionFormLoadCodes}
                                                handleFieldChange={handleFieldChange}
                                            />
                                        </TabItem>
                                        <TabItem title="User Defined">
                                            <UserDefinedTab
                                                formFields={formFields}
                                                setformFields={setformFields}
                                                formRefs={formRefs}
                                                dialogVisible={dialogVisible}
                                                closeDialog={closeDialog}
                                                handleChangeDimensionButtonClick={handleChangeDimensionButtonClick}
                                                selectionPriority={selectionPriority}
                                                setSelectionPriority={setSelectionPriority}
                                                 Module ={props.Module}
                                            />
                                        </TabItem>
                                        <TabItem title="Proximity" disabled={formFields.RowId === '00000000-0000-0000-0000-000000000000'} >
                                            <ProximityTab warehouseRowId={formFields.RWarehouse} sourceId={formFields.RowId} Module={WM} />
                                        </TabItem>
                                    </TabPanel>
                                </div>
                                <div className="row">
                                    <ValidationSummary className="pl-3 pt-1" id="summary" />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

            </div>

        </>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(LocationDataEntryForm);